// JavaScript Document
//components/configuration/standard/forms/AutoDim.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
//import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';
//import {flexbox} from '@material-ui/system';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
//import ButtonGroup from '@material-ui/core/ButtonGroup';
//import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
//import Display from '../../display/Display';
//import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
	advancedCard : {
		margin: theme.spacing(1),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center"
	},
	advancedContent : {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		justifyContent: "space-around",
	},
	timingInput : {
		margin: theme.spacing(1),
		width: 90
	},
  maxDisplayGrid: {
	  minHeight: 300
  }
}));

export default function MaxDisplaySpeed(props) {
  	const classes = useStyles();
	//inherited variables
  	const {id, day, night, onChange} = props;
	//locally stored/copied variables
	const [cid, setCid] = React.useState(0);
	//local state varialbes user will change
	
	const [maxBright, setMaxBright] = React.useState(99);
	const [minBright, setMinBright] = React.useState(10);
	//local copy of config (shouldn't change parent except with onChange)
	/*
	const [myConfig, setMyConfig] = React.useState({
		//keep all these until we're done here
		id : 0,
		//looks at messages for display
		messages : [],
		//display flash timing
		flashOnTime : 500,
		flashOffTime : 500,
		flashPeriod: 4, //seconds
		//Strobe timing
		strobeOnDelay: 500,
		strobeOnPeriod: 500,
		//auto dimming min/max
		dayDimSetting: 99,
		nightDimSetting: 10,
		//Max display speed
		maxTwoDisplaySpeed:99,
		//Master Override 
		speedLimit: 25,
		threshold: 25,
		maxDisplaySpeed: 35,
		dimming: 99,
		mode: 1,
		enable: 0,
		//not yet sure what these do
		master_enable_on: 1,
		master_enable_off: 1,
		master_enable_power: 1,
		//Beacons
		alternateEnable: 1,
		wigOnPeriod: 500,
		wigOffPeriod: 500,
		wagOnPeriod: 500,
		wagOffPeriod: 500,
		beaconDimEnable: 0,
		//Mini display timing
		mtime: '500:500:500:500:500:500:500:500',
		loopPeriod: 4,
		ped_startFlash: 0, //on delay?
		ped_onPeriod: 4,
		
	});
	*/
	

	
	
	//Refresh UI on props change
	React.useEffect(() => {
		if(
			//inherited config ID is null
			cid === 0 || 
			cid === undefined || 
			cid === null || 
			cid === "0" || 
			//inherited daysetting has changed
			cid !== id 
			//updated from server
			//|| loadedToken != token
		) {
			//console.log('config has changed');
			setCid(id);
			setMaxBright(day);
			setMinBright(night);
		}
		//}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	//Handle update parent if onChange is provided
	const handleUpdateParent = (dayDim, nightDim) => {
		if(onChange){
			console.log('Updating parent');
			onChange(dayDim, nightDim);
		}
	}
	

	
	//handle change timing value
	const handleChangeValue = (e) => {
		let setting = e.target.name;
		let value = parseInt(e.target.value);
		
		//clean the value
		if(isNaN(value) || value < 0){
			value = 0;
		} else if(value > 99){
			value = 99;
		}
		if(setting === 'minBright'){
			setMinBright(value);
			handleUpdateParent(maxBright, value);
		} else if(setting === 'maxBright'){
			setMaxBright(value);
			handleUpdateParent(value, minBright);
		}
	}
	
  	//standard size: 
	//1 panel = 6 x 9 x 2 rows = 30 x 18

  	return (
    	<Card className={classes.advancedCard}>
			<CardHeader title="Automatic Dimming" />
	  		<CardContent className={classes.advancedContent}>
	  				<TextField 
							id="minBright" 
							name="minBright"
							label="Minimum"
							value={minBright.toString()} 
							className={classes.timingInput} 
							onChange={handleChangeValue}
							type="number" 
							inputProps={{min: '0', max:'255', step:'5', style: {textAlign:'center'}}}
					/>
					<TextField 
							id="maxBright" 
							name="maxBright"
							label="Maximum"
							value={maxBright.toString()} 
							className={classes.timingInput} 
							onChange={handleChangeValue}
							type="number" 
							inputProps={{min: '0', max:'255', step:'5', style: {textAlign:'center'}}}
					/>
	  		</CardContent>
	  	</Card>
  );
}
